<template>
    <BaseModal name="buyer-instructions" :adaptive="true" :width="'100%'" :max-width="630" :height="'auto'"
               :scrollable="true"
               title="Service Instructions"
               :subtitle="title"
               ok-button="Got it!"
               @before-open="beforeOpen">
        <div>
            <!-- Buyer Instructions -->
            <div class="tw-bg-infinity-background-emphasized-more tw-text-infinity-primary-text tw-rounded tw-overflow-hidden">
                <div class="tw-overflow-y-auto tw-p-4"  style="max-height: 40vh" v-html="instructions" />
            </div>

            <!-- Contact Details -->
            <order-contact-details class="tw-mt-3" />
        </div>
    </BaseModal>
</template>
<script>
import BaseModal from "../base/base-modal.vue";
import OrderContactDetails from "../order/order-contact-details";

export default {
    components: {
        OrderContactDetails,
        BaseModal
    },
    data() {
        return {
            title: '',
            instructions: ''
        };
    },
    methods: {
        beforeOpen(event) {
            this.title = `${event.params.title}`
            this.instructions = event.params.instructions
        },
    }
};
</script>
